import React from "react";
import Form from "react-bootstrap/Form";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

/**
 * 
 * @param tabIndex
 * @param ref
 * 
 * @returns 
 */
export default function Period({ tabIndex, dateRange, setDateRange }: { tabIndex: number, dateRange: any, setDateRange: any }) {
    const [startDate, endDate] = dateRange;
    return (
        <Form.Group className="form-group filter-period">
            <Form.Label>
                <span className="icon"></span>
                Période d'exploitation
            </Form.Label>
            <DatePicker
                tabIndex={tabIndex}
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => {
                    setDateRange(update);
                }}
                isClearable={true}
                className="form-control"
                dateFormat="dd/MM/yyyy"
            />
        </Form.Group>
    );
}